/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Report_Meta_DescriptionInputs */

const ja_playdata_report_meta_description = /** @type {(inputs: Playdata_Report_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2025年版 日本eスポーツレポートを無料でお申し込みいただけます。`)
};

const en_playdata_report_meta_description = /** @type {(inputs: Playdata_Report_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request your free copy of the 2025 Japan Esports Report from PLAYDATA.`)
};

/**
* | output |
* | --- |
* | "Request your free copy of the 2025 Japan Esports Report from PLAYDATA." |
*
* @param {Playdata_Report_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_report_meta_description = /** @type {((inputs?: Playdata_Report_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Report_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_report_meta_description(inputs)
	return en_playdata_report_meta_description(inputs)
});